import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const LIGHTNING_ROUTE = {
  name: 'lightning',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
  },

  DEFAULT: '',

  START: {
    name: 'start/:branchId',
    route(classId: string, branchId: string): string[] {
      return [...LIGHTNING_ROUTE.route(classId), 'start', branchId];
    }
  },

  GAMEPLAY: {
    name: 'gameplay/:lightningRoundId',
    route(classId: string, lightningRoundId: string): string[] {
      return [...LIGHTNING_ROUTE.route(classId), 'gameplay', lightningRoundId];
    }
  },

  RANKINGS: {
    name: 'rankings/:sectionId/:allSchools/:prevSectionId',
    route(classId: string, sectionId: string, allSchools: string, prevSectionId: string): string[] {
      return [...LIGHTNING_ROUTE.route(classId), 'rankings', sectionId, allSchools, prevSectionId];
    }
  }
};
